/* Publish by EComposer at 2026-10-27 06:11:25*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yluojqqtz1"]=  window.__ectimmers["ecom-yluojqqtz1"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-yluojqqtz1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yluojqqtz1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4hh4yst0dp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4hh4yst0dp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6lrvi65vnx7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6lrvi65vnx7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h452kv9c00v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h452kv9c00v', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qd4h2jtmnnf"]=  window.__ectimmers["ecom-qd4h2jtmnnf"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-qd4h2jtmnnf"]["v3cqm9jg2"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-qd4h2jtmnnf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qd4h2jtmnnf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z1lo1n3x64').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z1lo1n3x64', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-imgvwkha16g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-imgvwkha16g', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}